import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../user';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-permissions',
    imports: [
    FormsModule
],
    templateUrl: './permissions.component.html',
    styleUrl: './permissions.component.scss'
})
export class PermissionsComponent {

  constructor(
    public dialogRef: MatDialogRef<PermissionsComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: User
  ) {}

  save() {
    console.log(this.data)
    this.dialogRef.close(this.data)
  }
  close() {
    console.log(this.data)
    this.dialogRef.close(null)
  }
}
